import { root } from '../store/constants';

export const getStatServerUrl = (url: string): string  => {
    return root.Settings.statServerUrl + url;
};
